export interface LoadingState {
    general: boolean;
    auth: boolean;
    cloud: boolean;
    tournament: boolean;
    ping: boolean;
    network: boolean;
    socket: boolean;
    gps: boolean;
    restricted: boolean;
    download: boolean;
    social: boolean;
    profile: boolean;
    api: boolean;
    update: boolean;
    revenueCat: boolean;
    firestore: boolean;
}

export const LOADING_INIT_STATE: LoadingState = {
    general: false,
    auth: false,
    cloud: false,
    tournament: false,
    ping: false,
    network: false,
    socket: false,
    gps: false,
    restricted: false,
    download: false,
    social: false,
    profile: false,
    api: false,
    update: false,
    revenueCat: false,
    firestore: false,
}

export interface ISopoLoadingState {
    paused: boolean;
    presented: LoadingState;
}

export const SOPO_LOADING_INIT_STATE: ISopoLoadingState = {
    paused: false,
    presented: { ... LOADING_INIT_STATE },
}
